// extracted by mini-css-extract-plugin
module.exports = {"resultsHeadBar":"SerpContainer_resultsHeadBar__zINi0","resultsChips":"SerpContainer_resultsChips__bOGrL","totResults":"SerpContainer_totResults__qLpHw"};